import * as React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from 'src/shadcn/components/ui/dialog';
import { CustomerInfoView } from 'src/Components/FrontDeskPage/CustomerInfoView';
import * as uuid from 'uuid';
import { ScrollArea } from 'src/shadcn/components/ui/scroll-area';
import { JobSelectCustomerModalFooter } from './JobSelectCustomerModalFooter';
import { Customer } from './CustomerType';

export interface IJobSelectCustomerModalProps {
  onSelectCustomer: (c: Customer) => void;
  setIsOpen: (newIsOpen: boolean) => void;
  isOpen: boolean;
}

export const JobSelectCustomerModal: React.FunctionComponent<
  IJobSelectCustomerModalProps
> = props => {
  const [newCustomer, setNewCustomer] = React.useState<Partial<Customer>>({
    id: uuid.v4(),
  });
  const resetState = () => {
    setNewCustomer({ id: uuid.v4() });
  };
  return (
    <Dialog
      open={props.isOpen}
      onOpenChange={newIsOpen => {
        props.setIsOpen(newIsOpen);
        if (!newIsOpen) {
          resetState();
        }
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{'Create new customer'}</DialogTitle>
        </DialogHeader>
        <ScrollArea className='max-h-[70vh]'>
          <CustomerInfoView
            validations={{}}
            customer={newCustomer}
            setCustomer={customerToSet => {
              setNewCustomer(customerToSet as any);
            }}
          />
          <div className='mt-10'>
            <JobSelectCustomerModalFooter
              onSelectCustomer={props.onSelectCustomer}
              newCustomer={newCustomer}
              key={newCustomer.id || 'new'}
            />
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};
